<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen">
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content">
			<div class="container">
											
				<div class="mt-4 mb-4">
					<div class="card-body">
						<h5 class="card-title">Observaciones generales</h5>
						
						<b-form-group label="Comentarios" class="mt-4">
							<textarea-autosize
							placeholder="Comentarios"
							v-model="form.comments"
							:min-height="30"
							:max-height="350"
							class="form-control"
							/>
						</b-form-group>
						
						<b-form-group label="Archivos adjuntos" class="mt-4">
							<UploadMultiple
								v-model="form.files" 
								:placeholder="'Adjuntar archivo'" 
							></UploadMultiple>
						</b-form-group>

					</div>
				</div>
				
			</div>
		</div>

		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="finishControl()">
					Finalizar
				</div>
			</div>
		</div>

	</div>

	<ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess>

</div>
</template>


<script>
import gql from 'graphql-tag'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import UploadMultiple from '@/components/UploadMultiple'
import ControlSuccess from '@/views/controls/ControlSuccess'

export default {
	name: 'CarPreDelivery',
	components: {
		Loader,
		UploadMultiple,
		ControlSuccess
	},
	data(){
		return{
			loading: false,
			saving: false,
			API_URL: process.env.VUE_APP_API_URL,
			controlCreated: null,
			form:{
				comments:null,
				files: [],
			},
		}
	},
	computed: {
		...mapState(['control'])
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		finishControl(){
			if(!this.saving ) {
				this.$dialog
				.confirm('Confirmar despacho',{
					cancelText: 'Cancelar',
					okText: 'Confirmar'
				})
				.then(() => {
					this.finishControlOK()
				})
			}
		},
		finishControlOK(){
			this.saving = true
			let filesIds = this.form.files.map(a => a.id)
			let dataInput = {
				car_id 			: this.control.car.id,
				comments		: this.form.comments,
				files			: filesIds
			}
			return this.$apollo.mutate({
				mutation: gql`mutation ( $data:ControlDispatchInput! ){
					controlDispatch( data: $data) {
						id
						car{
							id
						}
						user{
							name
						}
						comments
						files{
							id
							filename
							extension
							url
							urlThumb
						}
						created_at
					}
				}`,
				variables: {
					data: dataInput
				}
			})
			.then((data) => {
				this.controlCreated = data.data.controlDispatch
				this.saving = false
				this.control.step = 'ControlSuccess'
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		}
	}
	
}
</script>

<style scoped lang="scss">

</style>
